import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Grandes empresas",
    correct: false,
  },
  {
    option: "b) Empresas financeiras de qualquer tamanho",
    correct: false,
  },
  {
    option: "c) Pequenos clientes do setor financeiro",
    correct: false,
  },
  {
    option: "d) Empresas médias e grandes que pagam comissões",
    correct: true,
  },
  {
    option: "e) Nenhuma das anteriores",
    correct: false,
  },
];

export default function Question33(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question33: {
          title: "Quais são os clientes-alvo da IMPROVE?",
          option: option.option,
          correct: option.correct,
          order: 33
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Quais são os clientes-alvo da IMPROVE?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
